import React from "react";

import { ZoneAvatar } from "@common/zoneAvatar";
import { Section } from "../../section";
import { Props } from "./types";
import { Projects } from "./projects";
import styles from "./styles.scss";

function Zone({ search, zone, selected, onSelect }: Props) {
  return (
    <Section
      header={
        <div className={styles.header}>
          <div className={styles.icon}>
            <ZoneAvatar name={zone.name} color={zone.color} />
          </div>
          <p className={styles.name}>{zone.name}</p>
        </div>
      }
      list={<Projects zone={zone} selected={selected} onSelect={onSelect} />}
      isOpen={!!search}
    />
  );
}

export { Zone };
